module.exports = __webpack_public_path__ + "img/align-horizontal-centre-02.398f457c.svg";